import $ from "jquery";
import lazyLoad from "./library/lazyload";
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/dropdown';
import unobtrusiveAjaxInit from "./library/unobtrusive-ajax";

window.$ = window.jQuery = $;

$(document).on("change", "select[data-auto-submit], input[data-auto-submit]",
    function () {
        $(this.form).trigger("submit");
    });

lazyLoad(window);
unobtrusiveAjaxInit($);

window.GetUnReadMessageCount = function () {
    var messageCountLink = $(".message-count-link");
    if (messageCountLink && messageCountLink.length > 0) {
        $.get('/Chatn/?handler=UnReadMessageCount').done(function (data) {
            if (data && data > 0) {
                $(messageCountLink[0]).find("span.icon").addClass("new");
                if ($(messageCountLink[0]).find("span.badge").length > 0)
                    $(messageCountLink[0]).find("span.badge").html(data);
                else
                    $(messageCountLink[0]).append("<span class='badge badge-danger text-white'>" + data + "</span>");
            } else {
                $(messageCountLink[0]).find("span.badge").remove();
                $(messageCountLink[0]).find("span.icon").removeClass("new");
            }
        }).fail(function (data) {
            console.log("error data:" + JSON.stringify(data));
        });
    }
};

var eventMethod = window.addEventListener ? "addEventListener" : "attachEvent";
var eventer = window[eventMethod];
var messageEvent = eventMethod === "attachEvent" ? "onmessage" : "message";
eventer(messageEvent, function (e) {
    //if (e.origin !== 'http://the-trusted-iframe-origin.com') return;
    if (e.data === "update_read_message_count_event" || e.message === "update_read_message_count_event") {
        window.GetUnReadMessageCount();
    }
});

if ($(".message-count-link").length > 0) {
    setInterval(function () { window.GetUnReadMessageCount(); }, 10000);
}
